import { ninjaConfig } from '../config/ninja';
import { regionConfig } from '../config/region';
import { hasRequiredConsentFor } from '../consent';
import { Trackers } from '../const';
import { getDefaultParams as ninjaGetDefaultParams } from '../core/params';
import { collectCalls } from '../core/utils';
import { makeMapping, makeObjectMapping } from '../mapping';

const SCRIPT_TAG_ID = 'braze-script-tag';
const SCRIPT_URL = 'https://js.appboycdn.com/web-sdk/5.7/braze.min.js';

// Link event
let isLinkEvent = false;
let initPushed = false;
let isDisabled = false;

function getToken() {
  let code = regionConfig.custom[ninjaConfig.siteUrl].config[Trackers.Braze].code;

  if (ninjaConfig.environment !== 'production') {
    // Allow Overwrite only on non-prod
    if (ninjaConfig.custom && ninjaConfig.custom.braze && ninjaConfig.custom.braze.siteCode) {
      code = ninjaConfig.custom.braze.siteCode;
    }
  }

  return code;
}

function getEndpoint() {
  let endpoint = regionConfig.custom[ninjaConfig.siteUrl].config[Trackers.Braze].endpoint;

  if (ninjaConfig.environment !== 'production') {
    // Allow Overwrite only on non-prod
    if (ninjaConfig.custom && ninjaConfig.custom.braze && ninjaConfig.custom.braze.endpoint) {
      endpoint = ninjaConfig.custom.braze.endpoint;
    }
  }

  return endpoint;
}

/* eslint-disable */
/* prettier-ignore */
/**
 * Official braze loading snippet. Modified to accept ID and callback
 * @see https://www.braze.com/docs/developer_guide/platform_integration_guides/web/initial_sdk_setup/#install-cdn
 */
function initBraze(a, p, P, b, y, id, c) {
  a.braze = {};
  a.brazeQueue = [];
  for (
    var s =
        'BrazeSdkMetadata DeviceProperties Card Card.prototype.dismissCard Card.prototype.removeAllSubscriptions Card.prototype.removeSubscription Card.prototype.subscribeToClickedEvent Card.prototype.subscribeToDismissedEvent Card.fromContentCardsJson ImageOnly CaptionedImage ClassicCard ControlCard ContentCards ContentCards.prototype.getUnviewedCardCount Feed Feed.prototype.getUnreadCardCount ControlMessage InAppMessage InAppMessage.SlideFrom InAppMessage.ClickAction InAppMessage.DismissType InAppMessage.OpenTarget InAppMessage.ImageStyle InAppMessage.Orientation InAppMessage.TextAlignment InAppMessage.CropType InAppMessage.prototype.closeMessage InAppMessage.prototype.removeAllSubscriptions InAppMessage.prototype.removeSubscription InAppMessage.prototype.subscribeToClickedEvent InAppMessage.prototype.subscribeToDismissedEvent InAppMessage.fromJson FullScreenMessage ModalMessage HtmlMessage SlideUpMessage User User.Genders User.NotificationSubscriptionTypes User.prototype.addAlias User.prototype.addToCustomAttributeArray User.prototype.addToSubscriptionGroup User.prototype.getUserId User.prototype.getUserId User.prototype.incrementCustomUserAttribute User.prototype.removeFromCustomAttributeArray User.prototype.removeFromSubscriptionGroup User.prototype.setCountry User.prototype.setCustomLocationAttribute User.prototype.setCustomUserAttribute User.prototype.setDateOfBirth User.prototype.setEmail User.prototype.setEmailNotificationSubscriptionType User.prototype.setFirstName User.prototype.setGender User.prototype.setHomeCity User.prototype.setLanguage User.prototype.setLastKnownLocation User.prototype.setLastName User.prototype.setPhoneNumber User.prototype.setPushNotificationSubscriptionType User.prototype.setLineId InAppMessageButton InAppMessageButton.prototype.removeAllSubscriptions InAppMessageButton.prototype.removeSubscription InAppMessageButton.prototype.subscribeToClickedEvent FeatureFlag FeatureFlag.prototype.getStringProperty FeatureFlag.prototype.getNumberProperty FeatureFlag.prototype.getBooleanProperty FeatureFlag.prototype.getImageProperty FeatureFlag.prototype.getJsonProperty FeatureFlag.prototype.getTimestampProperty Banner automaticallyShowInAppMessages destroyFeed hideContentCards showContentCards showFeed showInAppMessage deferInAppMessage toggleContentCards toggleFeed changeUser destroy getDeviceId getDeviceId initialize isPushBlocked isPushPermissionGranted isPushSupported logCardClick logCardDismissal logCardImpressions logContentCardImpressions logContentCardClick logCustomEvent logFeedDisplayed logInAppMessageButtonClick logInAppMessageClick logInAppMessageHtmlClick logInAppMessageImpression logPurchase openSession requestPushPermission removeAllSubscriptions removeSubscription requestContentCardsRefresh requestFeedRefresh refreshFeatureFlags requestImmediateDataFlush enableSDK isDisabled setLogger setSdkAuthenticationSignature addSdkMetadata disableSDK subscribeToContentCardsUpdates subscribeToFeedUpdates subscribeToInAppMessage subscribeToSdkAuthenticationFailures toggleLogging unregisterPush wipeData handleBrazeAction subscribeToFeatureFlagsUpdates getAllFeatureFlags logFeatureFlagImpression requestBannersRefresh insertBanner logBannerClick logBannerImpressions getAllBanners subscribeToBannersUpdates isInitialized'.split(
          ' '
        ),
      i = 0;
    i < s.length;
    i++
  ) {
    for (var m = s[i], k = a.braze, l = m.split('.'), j = 0; j < l.length - 1; j++) k = k[l[j]];
    k[l[j]] = new Function('return function ' + m.replace(/\./g, '_') + '(){window.brazeQueue.push(arguments); return true}')();
  }
  window.braze.getDeferredInAppMessage = function () {
    return new window.braze.InAppMessage();
  };
  window.braze.getCachedContentCards = function () {
    return new window.braze.ContentCards();
  };
  window.braze.getCachedFeed = function () {
    return new window.braze.Feed();
  };
  window.braze.getUser = function () {
    return new window.braze.User();
  };
  window.braze.getFeatureFlag = function () {
    return new window.braze.FeatureFlag();
  };
  window.braze.getBanner = function () {
    return new window.braze.Banner();
  };
  window.braze.newBannerFromJson = function () {
    return new window.braze.Banner();
  };
  (y = p.createElement(P)).type = 'text/javascript';
  y.src = SCRIPT_URL;
  y.async = 1;
  y.onload = c;
  y.id = id;
  (b = p.getElementsByTagName(P)[0]).parentNode.insertBefore(y, b);
}
/* eslint-enable */

// Internal function - enable SDK is previously disabled and initialize
function enable_and_initialize(code, endpoint) {
  isDisabled = false;
  if (window.braze.isDisabled()) {
    window.braze.enableSDK();
  }
  window.braze.initialize(code, {
    baseUrl: endpoint,
    enableLogging: ninjaConfig.environment !== 'production',
    doNotLoadFontAwesome: true,
  });
}

// Internal function - Init the tracker
function init(params, callBack) {
  if (!hasRequiredConsentFor(Trackers.Braze)) {
    cleanup();
    return;
  }
  const code = getToken();
  const endpoint = getEndpoint();
  const oldTag = document.getElementById(SCRIPT_TAG_ID);

  if (!code || !endpoint) {
    return;
  }

  initPushed = false;
  if (oldTag) {
    initPushed = true;
  }

  if (!initPushed) {
    initBraze(window, document, 'script', null, null, SCRIPT_TAG_ID, function () {
      initPushed = true;
      if (window.braze) {
        enable_and_initialize(code, endpoint);
        if (typeof window.brazeInitCallback === 'function') {
          window.brazeInitCallback(window.braze);
        }
      }

      if (callBack) {
        callBack();
      }
    });
  } else {
    if (isDisabled && window.braze) {
      // when enabling the disabled Braze tracker we need to initialize it once again
      enable_and_initialize(code, endpoint);
    }

    if (callBack) {
      callBack();
    }
  }
}

// Disable SDK
export function cleanup() {
  if (window.braze) {
    window.braze.disableSDK();
    isDisabled = true;
  }
}

function convertString(text) {
  if (typeof text === 'string') {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9\/_]/g, '-')
      .replace(/\s{2}/g, ' ')
      .replace(/\s/g, '-')
      .replace(/---/g, '-')
      .replace(/---/g, '-')
      .replace(/--/g, '-');
  }
  return text;
}

// Internal function - Callback after finish one hit
function onHitSentOk() {
  if (isLinkEvent) {
    collectCalls();
    isLinkEvent = false;
  }
}

/******************* */

// Entry function - Track a page
export function trackPage(params) {
  init(params, function () {
    let trackParams = getTrackParams(params);
    let newValues = makeMapping(Trackers.Braze, 'trackPage', params.pageName);

    if (newValues.key === false || newValues.value === false) {
      return;
    }

    let pageName = newValues.value;

    if (window.braze && typeof window.braze.logCustomEvent === 'function') {
      window.braze.logCustomEvent(pageName, trackParams);
    }
  });
}

// Entry function - Track an event
export function trackEvent(params) {
  init(params, function () {
    if (params.eventData.category) {
      const eventData = [];
      const trackParams = getTrackParams(params);

      if (params.eventData.category) {
        eventData.push(params.eventData.category);
      }
      if (params.eventData.action) {
        eventData.push(params.eventData.action);
      }
      if (params.eventData.label) {
        eventData.push(params.eventData.label);
      }
      if (params.eventData.value) {
        eventData.push(params.eventData.value);
      }

      let eventName = convertString(eventData.join('_'));

      let newValues = makeMapping(Trackers.Braze, 'trackEvent', eventName);
      if (newValues.key === false || newValues.value === false) {
        onHitSentOk();
        return;
      }

      eventName = newValues.value;

      if (window.braze && typeof window.braze.logCustomEvent === 'function') {
        window.braze.logCustomEvent(eventName, trackParams);
        onHitSentOk();
      }
    }
  });
}

// Entry function - Track a link event
export function trackLinkEvent(params) {
  isLinkEvent = true;
  trackEvent(params);
}

function getCustomParams(params) {
  return makeObjectMapping(Trackers.Braze, params.customParams);
}

/**
 * Get list of default params
 * @returns {Record<string, any>}
 */
function getDefaultParams() {
  return {};
}

/**
 * Get signle object containing custom, ninja default and tracker default params.
 * They are encoded and mapped to the tracker's matrix
 * @param {Record<string, any>} params
 * @returns {Record<string, any>}
 */
function getTrackParams(params) {
  const customParams = getCustomParams(params);
  const ninjaDefaultParams = makeObjectMapping(Trackers.Braze, ninjaGetDefaultParams(params));
  const moduleDefaultParams = makeObjectMapping(Trackers.Braze, getDefaultParams());

  // apply shared default params
  let trackParams = Object.assign({}, customParams, ninjaDefaultParams);

  // apply tracker's default params
  trackParams = Object.assign({}, trackParams, moduleDefaultParams);

  return trackParams;
}
